import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  lowAvailability: {
    id: 'boutiqueStock.lowAvailability',
    defaultMessage: 'Low availability',
  },
  onlyFewLeft: {
    id: 'boutiqueStock.onlyFewLeft',
    defaultMessage: 'Only few left',
  },
  available: {
    id: 'boutiqueStock.available',
    defaultMessage: 'Available',
  },
});
